import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import CustomHelmet from "../components/seo/CustomHelmet";
import { useInView } from "react-intersection-observer";
import clsx from "clsx";
import { useLang } from "../translations/i18n";
import { Link } from "react-router-dom";
import { SERVER_URL } from "../utils";
import { usePress } from "../hooks/usePress";

const GridElem = ({ title, subtitle, date, content, image, url, id, lang }) => {
  return (
    <div className="col-12 col-lg-3 my-3">
      <div className="bgbrown px-1 py-1 br20 h-100">
        <Link to={url} state={{ id: id }} title="--" class="--">
          <div className="mb-2 bgwhite containerimggallery br15">
            <img src={image} className="imggallery" />
          </div>
          {/* How can I reduce the size of the h1, I must mantain the H1 for the SEO but I need it to be smaller */}
          <h1 className="mb-0" style={{ fontSize: "18px" }}>
            {title}
          </h1>
          <div className="mb-1 datefont">{formatDate(date, lang)}</div>
        </Link>
      </div>
    </div>
  );
};

const formatDate = (date, lang) => {
  if (date) {
    return new Intl.DateTimeFormat(lang, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(date));
  }
};

function PressNews({ intl }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const lang = useLang();
  const { ref, inView /*, entry*/ } = useInView({
    /* Optional options */
    threshold: 0,
    delay: 1500,
    triggerOnce: true,
  });

  const { handleFetchPress } = usePress();

  useEffect(() => {
    window.scrollTo(0, 0);
    const asyncFetch = async () => {
      const data = await handleFetchPress({ setLoading });
      setData(data);
    };
    asyncFetch();
  }, []);

  return (
    <>
      <CustomHelmet
        title={intl.formatMessage({ id: "PRESSNEWS.TITLESEO" }) || ""}
        description={
          intl.formatMessage({ id: "PRESSNEWS.DESCRIPTIONSEO" }) || ""
        }
      />
      <div className="container my-5">
        <div className="row">
          <div className="col-12 text-center py-5">
            <div>
              <h1>
                <div
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage({ id: "PRESSNEWS.TITLE" }),
                  }}
                />
              </h1>
              <p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage({ id: "PRESSNEWS.SUBTITLE" }),
                  }}
                />
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {data &&
            data?.map((elem) => (
              <GridElem
                title={elem.title && elem.title[lang]}
                subtitle={elem.subtitle && elem.subtitle[lang]}
                date={elem.date}
                image={`${SERVER_URL}/${elem.filesURLs[0]}`}
                url={`${intl.formatMessage({ id: "PRESSNEWS.FOLDER" }) || ""}/${
                  elem.title &&
                  elem.title[lang]
                    ?.replace(/\s+/g, "-")
                    .replace(/[^\w\s-]/g, "")
                    .replace(/-+/g, "-")
                    .toLowerCase()
                }?${elem._id}`}
                id={elem._id}
                lang={lang}
              />
            ))}
        </div>
      </div>
    </>
  );
}

export default injectIntl(PressNews);
